<template>
  <div class="setting-main-container">
    <form action="" @submit.prevent="submitCustomerData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('general.credit_details') }}</h3>
        </div>
        <div class="row  mb-4">
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.credit_limit') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.credit_limit.$error}"
                v-model="formData.credit_limit"
                v-bind="customerCurrency"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.credit_limit.$error">
              <span v-if="!$v.formData.credit_limit.minValue" class="form-group__message text-danger">{{ $t('validation.enter_credit_greater_than_used_credit') }}</span>
            </div>
          </div>
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.used_credit') }}</label><span class="text-danger"> * </span>
            <div class="base-read-box base-read-box-field">
              <div v-html="$utils.formatMoney(used_credit, customerCurrencyViewFormat)" />
            </div>

          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-6 mb-6">
            <label  class="input-label">{{ $t('general.starting_date') }}<span class="text-danger"> * </span></label>

            <base-date-picker
              v-model="formData.starting_date"
              :calendar-button="true"
              calendar-button-icon="calendar"
              @change="$v.formData.starting_date.$touch()"
            />
            <span v-if="$v.formData.starting_date.$error && !$v.formData.starting_date.required" class="text-danger"> {{ $t('validation.required') }} </span>
          </div>
          <div class="col-md-6 mb-6">
            <label  class="input-label">{{ $t('general.renewal_date') }}<span class="text-danger"> * </span></label>

            <base-date-picker
              v-model="formData.renewal_date"
              :calendar-button="true"
              calendar-button-icon="calendar"
              @change="$v.formData.renewal_date.$touch()"
            />
            <span v-if="$v.formData.renewal_date.$error && !$v.formData.renewal_date.required" class="text-danger"> {{ $t('validation.required') }} </span>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-6 mb-6">
            <label  class="input-label">{{ $t('general.type_of_credit') }}<span class="text-danger"> * </span></label>
            <base-select
              v-model="formData.type_of_credit"
              :options="CreditTypes"
              :class="{'error': $v.formData.type_of_credit.$error }"
              :searchable="true"
              :show-labels="false"
              :allow-empty="false"
              :placeholder="$t('general.type_of_credit')"
            />
            <span v-if="$v.formData.type_of_credit.$error && !$v.formData.type_of_credit.required" class="text-danger"> {{ $t('validation.required') }} </span>
          </div>
          <div class="col-md-6 mb-6">
            <label  class="input-label">{{ $t('general.type_of_collateral') }}<span class="text-danger"> * </span></label>
            <base-select
              v-model="formData.type_of_collateral"
              :options="CollateralTypes"
              :class="{'error': $v.formData.type_of_collateral.$error }"
              :searchable="true"
              :show-labels="false"
              :allow-empty="false"
              :placeholder="$t('general.type_of_collateral')"
            />
            <span v-if="$v.formData.type_of_collateral.$error && !$v.formData.type_of_collateral.required" class="text-danger"> {{ $t('validation.required') }} </span>
          </div>

        </div>

        <div class="row  mb-4">
          <div class="col-md-12 input-group">
            <base-button
              :loading="isLoading"
              :disabled="isLoading"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $tc('profile.business_status.save') }}
            </base-button>
          </div>
        </div>


      </div>
    </form>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
import moment from 'moment'
const { required, email, minValue, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
    isLoading: false,
    formData:{
      credit_limit:0,
      renewal_date:null,
      starting_date:null,
      type_of_credit:null,
      type_of_collateral:null
     },
     used_credit:0,
     receivePayments:[],
     CreditTypes:['Supply Chain Finance','General'],
     CollateralTypes:['Invoice','Hypothecation','Other'],
     credit_limit_min: Number.MAX_SAFE_INTEGER,
    }
  },
  computed: {
    ...mapGetters('customer', [
      'viewCustomer'
    ]),
     ...mapGetters('currency', [
      'defaultCurrencyForInput'
    ]),
    customerCurrency () {
      if (this.viewCustomer && this.viewCustomer.currency) {
        return {
          decimal: this.viewCustomer.currency.decimal_separator,
          thousands: this.viewCustomer.currency.thousand_separator,
          prefix: this.viewCustomer.currency.symbol + ' ',
          precision: this.viewCustomer.currency.precision,
          masked: false
        }
      } else {
        return this.defaultCurrencyForInput
      }
    },
    customerCurrencyViewFormat(){
      if(this.viewCustomer && this.viewCustomer.account && this.viewCustomer.account.currency){
        return this.viewCustomer.account.currency
      }
      if(this.viewCustomer &&  this.viewCustomer.currency){
        return this.viewCustomer.currency
      }
    }
  },
  created() {
    this.getCompanyImpactOnAccount()
  },
  validations () {
    return {
      formData: {
        credit_limit:{
          required,
          between: minValue(this.credit_limit_min)
        },
        starting_date: {
          required
        },
        renewal_date: {
          required
        },
        type_of_credit: {
          required
        },
        type_of_collateral: {
          required
        },
      }
    }
   },
  mounted () {

  },
  methods: {
    ...mapActions('companyImpactOthers', [
      'addCompanyImpactOthers',
      'getImpact'
    ]),
    ...mapActions('invoice', [
      'fetchInvoices',
    ]),
    ...mapActions('customer', [
      'fetchViewCustomer'
    ]),
    async getCompanyImpactOnAccount(){
      let response
      if(this.viewCustomer && this.viewCustomer.default_company_id && localStorage.getItem('selectedCompany')){
          let data = {
          company_id: localStorage.getItem('selectedCompany'),
          guest_company_id: this.viewCustomer.default_company_id
        }
        response = await this.getImpact(data)
      }else{
        let customer_response = await this.fetchViewCustomer(this.$route.params.id)
        if(customer_response.data && customer_response.data.customer.default_company_id){
            let data = {
              company_id: localStorage.getItem('selectedCompany'),
              guest_company_id: customer_response.data.customer.default_company_id
            }
          response = await this.getImpact(data)
        }
      }

      if (response.data) {
        if(response.data.credit_limit){
          this.formData.credit_limit = response.data.credit_limit
        }
        if(response.data.type_of_credit){
          this.formData.type_of_credit = response.data.type_of_credit
        }
        if(response.data.type_of_collateral){
          this.formData.type_of_collateral = response.data.type_of_collateral
        }
        if(response.data.starting_date){

          this.formData.starting_date = moment(new Date(response.data.starting_date), 'YYYY-MM-DD').toString()
        }
        if(response.data.renewal_date){
          this.formData.renewal_date = moment(new Date(response.data.renewal_date), 'YYYY-MM-DD').toString()
        }
        if(response.data.renewal_date){
          this.used_credit = response.data.used_credit
        }if(response.data.used_credit){
          this.credit_limit_min = response.data.used_credit/100
        }else{
          this.credit_limit_min =0
        }
      }
    },
    async submitCustomerData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      this.isLoading = true
      let data = {
        guest_user_id: this.$route.params.id,
        credit_limit: this.formData.credit_limit.toFixed(2),
        type_of_collateral:this.formData.type_of_collateral,
        type_of_credit:this.formData.type_of_credit,
        starting_date: moment(this.formData.starting_date).toString(),
        renewal_date: moment(this.formData.renewal_date).toString(),
      }
      let response = await this.addCompanyImpactOthers(data)
      if (response.data.result) {
        window.toastr['success'](this.$t('customers.updated_message'))
        this.isLoading = false
      }
    },
  }
}
</script>
